import { InjectionToken } from "@angular/core";
import { QuantityUnitDto } from "../../INTEGRA_Shop_Client";

export interface ISalesUnitService {
  defaultSalesUnitGet(salesUnitList: QuantityUnitDto[] | undefined): QuantityUnitDto | undefined;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ISalesUnitServiceToken = new InjectionToken<ISalesUnitService>('ISalesUnitServiceToken');
